// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"blog-result-module--wrapper--3F6PP","blogImg":"blog-result-module--blogImg--YRqiT","styledLink":"blog-result-module--styledLink--24c8f"};